const data = {
  sectionConfig: {
    padding: {
      desktop: '40px 0',
      tablet: '40px 0',
      mobile: '40px 0'
    }
  },
  company: 'Axel Steiner<br/> Mannheimer Str. 10<br/> 69469 Weinheim',
  provider: 'ALL-INKL',
  customCookieScriptTag: {
    id: 'CookieDeclaration',
    src:
      'https://consent.cookiebot.com/9193f2ba-0516-4cac-9c05-bc37ec254c40/cd.js',
    type: 'text/javascript',
    async: true
  }
}

export default data
